// // Cuz, St. Peter holds the keys
// export default class Gate{
//     constructor(user){
//         this.user=user;

//     }
//     isGreyManager(){
//         return this.user.type === 'greyman';
//     }
//     isSysAdmin(){
//         return this.user.type === 'sysadmin';
//     }
//     isAppAdmin(){
//         return this.user.type === 'appadmin';
//     }
//     isUser(){
//         return this.user.type === 'user';
//     }
// }

export default class Gate{
    constructor(user){
        this.user=user;

    }
    isGreyManager(){
        return this.user.user_type === 'grey-man';
    }
    isSysAdmin(){
        return this.user.user_type === 'sys-admin';
    }
    isZonalManager(){
        return this.user.user_type === 'zonal-manager';
    }
    isServiceAdmin(){
        return this.user.user_type === 'service-admin';
    }
    isServiceManager(){
        return this.user.user_type === 'service-manager';
    }
    isExpenseAdmin(){
        return this.user.user_type === 'expense-admin';
    }
    isPurchaseAdmin(){
        return this.user.user_type === 'purchase-admin';
    }
    isPurchaseManager(){
        return this.user.user_type === 'purchase-manager';
    }
    isReplacementManager(){
        return this.user.user_type === 'replacement-manager';
    }
    isDOAManager(){
        return this.user.user_type === 'doa-manager';
    }
    isExtWarrAdmin(){
        return this.user.user_type ==='ext-warr-admin';
    }
    isAuditor(){
        return this.user.user_type === 'auditor';
    }

    isAuditorVendors(){
        return this.user.user_type === 'auditor-vendors';
    }

    isHRAdmin(){
        return this.user.user_type === 'hr-admin';
    }

    isMarketingAdmin(){
        return this.user.user_type === 'marketing-admin';
    }

    isMarketingManager(){
        return this.user.user_type === 'marketing-manager';
    }

    isOnlineSalesManager(){
        return this.user.user_type === 'online-sales-manager';
    }

    isOnlineSalesAssociate(){
        return this.user.user_type === 'online-sales-associate';
    }
    isStoreManager(){
        return this.user.user_type === 'store-manager';
    }
    isBranchManager(){
        return this.user.user_type === 'branch-manager';
    }
    isBranchAccountant(){
        return this.user.user_type === 'branch-accountant';
    }
    isB2CSalesExecutive(){
        return this.user.user_type === 'b2c-sales-executive';
    }
    isB2BSalesExecutive(){
        return this.user.user_type === 'b2b-sales-executive';
    }
    isVendor(){
        return this.user.user_type === 'vendor';
    }
    isBrandPromoter(){
        return this.user.user_type === 'brand-promoter';
    }
    isServiceTech(){
        return this.user.user_type === 'service-tech';
    }
    isServiceAgent(){
        return this.user.user_type === 'service-agent';
    }
    isInstallationAdmin(){
        return this.user.user_type === 'installation-admin';
    }
    isInstallationAgent(){
        return this.user.user_type === 'installation-agent';
    }
    isCCManager(){
        return this.user.user_type === 'cc-manager';
    }

    isCCAgent(){
        return this.user.user_type === 'cc-agent';
    }
    isMISAdmin(){
        return this.user.user_type === 'mis-admin';
    }

    isSecondaryMISAdmin(){
        return this.user.user_type === 'secondary-mis-admin';
    }

    isSecondaryPurchaseAdmin(){
        return this.user.user_type === 'secondary-purchase-admin';
    }

    isSecondaryPurchaseManager(){
        return this.user.user_type === 'secondary-purchase-manager';
    }
    isWarehouseManager(){
        return this.user.user_type === 'warehouse-manager';
    }
    isDeliveryDriver(){
        return this.user.user_type === 'delivery-driver';
    }
    isUser(){
        return this.user.user_type === 'user';
    }
}
